namespace Portico.Directives {
    import pm = Portico.Models;
    import pme = Portico.Models.Enterprise;
    import pmi = Portico.Models.Interfaces;
    import pms = Portico.Models.Setup;
    import ps = Portico.Services;

    export interface ITcPdfCardController {
        clazz: string;
        key: string;
        label: string;
        method: string;
        value: string;
    }

    export class TcPdfCardController implements ITcPdfCardController {
        clazz: string;
        key: string;
        label: string;
        method: string;
        value: string;
    }

    angular.module('app').directive('tcPdfCard', [
        '$compile',
        '$state',
        'dataService',
        'serverConstants',
        (
            $compile: angular.ICompileService,
            $state: angular.ui.IStateService,
            dataService: ps.IDataService,
            serverConstants: pmi.IServerConstants
        ) => {
            return {
                bindToController: {
                    clazz: '@',
                    key: '@',
                    label: '@',
                    method: '@',
                    value: '=', // change to an object (mapped values)
                },
                controller: <any>TcPdfCardController,
                controllerAs: '$pdf',
                link: (
                    $scope: angular.IScope,
                    $element: angular.IAugmentedJQuery,
                    $attr: angular.IAttributes,
                    $ctrl: any[],
                    $transclude: angular.ITranscludeFunction
                ) => {
                    const tcPdfCard: ITcPdfCardController = $ctrl[0];

                    const clazz = tcPdfCard.clazz ? tcPdfCard.clazz : '';
                    const key = tcPdfCard.key ? tcPdfCard.key : '';
                    const label = tcPdfCard.label ? tcPdfCard.label : '';
                    const method = tcPdfCard.method ? tcPdfCard.method : 'post';
                    const value = tcPdfCard.value ? tcPdfCard.value : '';

                    const template = dataService.getDataValue('PDF', 'Template', key);
                    const filename = dataService.getDataValue('PDF', 'Filename', key);
                    const contents = dataService.getDataValue('PDF', 'Contents', key);
                    const pdfContents: any[] = angular.fromJson(contents);

                    let html = '';
                    let transclusion = '';

                    $transclude(function(clone) {
                        clone.each(function(index, node) {
                            transclusion += node.textContent ? node.textContent : node.outerHTML;
                        });
                    });

                    transclusion = transclusion.trim() || label;

                    if (method === 'get') {
                        let queryString = `${
                            serverConstants.pdfPath
                        }/card?pdfRequest.filename=${filename}&pdfRequest.template=${template}`;

                        pdfContents.forEach((c: any, index: number) => {
                            queryString += `&pdfRequest.pdfContents[${index}].page=${c.page}`;
                            queryString += `&pdfRequest.pdfContents[${index}].content=${
                                value[c.content]
                            }`;
                            queryString += `&pdfRequest.pdfContents[${index}].font=${c.font}`;
                            queryString += `&pdfRequest.pdfContents[${index}].size=${c.size}`;
                            queryString += `&pdfRequest.pdfContents[${index}].style=${c.style}`;
                            queryString += `&pdfRequest.pdfContents[${index}].color=${c.color}`;
                            queryString += `&pdfRequest.pdfContents[${index}].point.x=${c.point.x}`;
                            queryString += `&pdfRequest.pdfContents[${index}].point.y=${c.point.y}`;
                        });

                        html = `<a class="${clazz}" href="${queryString}" target="_blank">
								${transclusion}
							</a>`;
                    } else {
                        let htmlContents = '';

                        pdfContents.forEach((c: any, index: number) => {
                            htmlContents += `<input name="pdfRequest.pdfContents[${index}].page" type="hidden" value="${
                                c.page
                            }" />
								<input name="pdfRequest.pdfContents[${index}].content" type="hidden" value="${value[c.content]}" />
								<input name="pdfRequest.pdfContents[${index}].font" type="hidden" value="${c.font}" />
								<input name="pdfRequest.pdfContents[${index}].size" type="hidden" value="${c.size}" />
								<input name="pdfRequest.pdfContents[${index}].style" type="hidden" value="${c.style}" />
								<input name="pdfRequest.pdfContents[${index}].color" type="hidden" value="${c.color}" />
								<input name="pdfRequest.pdfContents[${index}].point.x" type="hidden" value="${c.point.x}" />
								<input name="pdfRequest.pdfContents[${index}].point.y" type="hidden" value="${c.point.y}" />`;
                        });

                        html = `<form action="${serverConstants.pdfPath}/card" method="POST">
								<input name="pdfRequest.filename" type="hidden" value="${filename}" />
								<input name="pdfRequest.template" type="hidden" value="${template}" />
								${htmlContents}
								<a class="${clazz}" onclick="this.parentElement.submit();" role="button">${transclusion}</a>								
							</form>`;
                    }

                    $element.html(html);
                    $compile($element.contents() as any)($scope);
                },
                replace: true,
                require: ['tcPdfCard'],
                restrict: 'E',
                scope: true,
                transclude: true,
            };
        },
    ]);
}
